import React from "react";
import { decodeKey, encodeKey } from "../components/options/dropdown-options/helpers";
function selectedKeyToSet(selectedKey) {
    const encodedKey = encodeKey(selectedKey);
    return new Set(encodedKey != null ? [encodedKey] : []);
}
export function useListboxSelectionHelper(selectedKey, onChanged) {
    const [selectedKeys, setSelectedKeys] = React.useState(selectedKeyToSet(selectedKey));
    React.useEffect(() => {
        setSelectedKeys(selectedKeyToSet(selectedKey));
    }, [selectedKey]);
    const handleOnSelectionChange = React.useCallback((keys) => {
        if (keys === "all") {
            throw new Error("the 'all' should not be selected");
        }
        const values = Array.from(keys.values());
        if (values.length > 0) {
            // we do not want to allow deselecting an option by clicking on the
            // currently selected item. When that happens, the listbox will return
            // an empty Set of keys. If we ignore that event, the listbox will not
            // update and we get the desired behavior.
            // otherwise use the first selection (we currently only support single selection mode)
            onChanged({
                choiceKey: decodeKey(values[0]),
            });
            setSelectedKeys(new Set(values));
        }
    }, [onChanged]);
    return {
        selectedKeys,
        handleOnSelectionChange,
    };
}
//# sourceMappingURL=use-listbox-selection-helper.js.map